export class Exception<Details = unknown> extends Error {
  private readonly code: string | number;

  private readonly details: Details | null;

  constructor(code: string | number, message: string, details: Details | null) {
    super(message);

    this.code = code;
    this.details = details;
  }

  public getCode(): string | number {
    return this.code;
  }

  public getMessage(): string {
    return this.message;
  }

  public getDetails(): Details | null {
    return this.details;
  }
}
